import { fetchUtils } from 'react-admin'

const apiUrl = process.env.REACT_APP_BACKEND_API // TODO

const upperFirst = require('lodash.upperfirst')

const httpClient = fetchUtils.fetchJson

const buildAuthHeaders = () => {
  const token = localStorage.getItem('auth')
  const headers = new Headers({ Accept: 'application/json', auth: token })

  return headers
}

export const sendTest = async (resource, params) => {
  const headers = buildAuthHeaders()
  const endpointId = `sendTest${upperFirst(resource)}`
  return httpClient(`${apiUrl}/${endpointId}`, {
    headers,
    method: 'POST',
    body: JSON.stringify(params.data),
  }).then(({ json }) => ({
    data: { ...params.data, id: json.id },
  }))
}
